// Logos de bancos para la Conciliación Bancaria (Iter 401).
// Mapeo por ID de banco de Alegra (robusto) con respaldo por número de cuenta normalizado.
const POR_ALEGRA_ID = {
  20: '/bank-logos/banco-chile-1.png',
  23: '/bank-logos/banco-chile-2.png',
  24: '/bank-logos/bci.png',
  49: '/bank-logos/itau.png',
};

const POR_CUENTA = {
  '009230159910': '/bank-logos/banco-chile-1.png',
  '009230261402': '/bank-logos/banco-chile-2.png',
  '52559971': '/bank-logos/bci.png',
  '390001000231600425': '/bank-logos/itau.png',
};

export const logoBanco = (banco) => {
  if (!banco) return null;
  const id = banco.alegra_bank_id;
  if (id != null && POR_ALEGRA_ID[id]) return POR_ALEGRA_ID[id];
  const digitos = String(banco.cuenta || '').replace(/\D/g, '');
  return POR_CUENTA[digitos] || null;
};
